import React from 'react';
import PropTypes from 'prop-types';

import Box from 'components/atoms/Box/Box';

import Paragraph from 'components/atoms/Paragraph/Paragraph';
import Title from 'components/atoms/Title/Title';
import { useTheme } from '@material-ui/core';
import Division from 'components/atoms/Division/Division';

export default function NumberStat(props) {
  const { value, label, color, ...rest } = props;
  const theme = useTheme();
  const themeColor = theme && theme.palette.primary.main;
  const textColor = props.textColor ? props.textColor : themeColor;

  return (
    <Division>
      {value != null && (
        <Division>
          <Title textColor={textColor}>{value}</Title>
        </Division>
      )}
      <Division>
        <Paragraph variant="button" textColor={textColor} textSize="0.7rem">
          {label}
        </Paragraph>
      </Division>
    </Division>
  );
}

NumberStat.propTypes = {};

NumberStat.defaultProps = {};
